import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from '../../../../../../shared/enums/routing-enums';
import { SrmService } from '../../../../../../shared/service/srm.service';

@Component({
  selector: 'app-application-link-container',
  templateUrl: './application-link-container.component.html',
  styleUrls: ['./application-link-container.component.scss']
})
export class ApplicationLinkContainerComponent implements OnInit {

  public sectionId: number;
  public listApp: any[] = [];
  public title: string;
  public dataSource = new MatTableDataSource([]);
  public displayedColumns = ['title', 'action'];
  constructor(
    private router: Router,
    private srmService: SrmService,
    private spinner: Spinner,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(res => {
      if (res.sectionId) {
        this.sectionId = res.sectionId;
        this.getApplicationLinksById(this.sectionId);
      }
    });
  }

  public getApplicationLinksById(id) {
    this.spinner.show();
    this.srmService.getApplicationLinksBySectionId(this.sectionId).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        this.dataSource.data = res.data.applicationLinks;
        this.listApp = res.data.applicationLinks;
        this.title = res.data.title;
      }
    });
  }

  public deleteApp(id) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_DELETE_APPLICATION,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.spinner.show();
        this.srmService.deleteApplicationLink(id).subscribe((res: any) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.DELETE_APPLICATION_LINK);
            this.spinner.show();
            location.reload();
          }
        });
      }
    });
  }

  public add() {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'add-application-link', this.sectionId]);
  }

  public edit(id) {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-application-link', this.sectionId, id]);
  }

}
